var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-content",attrs:{"slot":"error-page"},slot:"error-page"},[_c('img',{staticClass:"error-img",attrs:{"src":require("../../assets/500.png"),"alt":""}}),_c('p',{staticClass:"p2"},[_vm._v("抱歉，服务器出错了")])])}
var staticRenderFns = []

export { render, staticRenderFns }